<template>
    <div>
        <div class="header"
             id="step-four">
            <div class="inner">
                <div class="l">
                    <img src="/resource/images/logo_main.png"
                         alt="易乐玩游戏盒子"
                         class="l" />
                    <router-link to="/"
                                 class="btnNav btnHome"
                                 :class="{'active': routeName === 1}"
                                 @click="fnNavClick(1, '首页')">
                        <svg xmlns="http://www.w3.org/2000/svg"
                             xmlns:xlink="http://www.w3.org/1999/xlink"
                             width="21px"
                             height="17px">
                            <path fill-rule="evenodd"
                                  fill="rgb(255, 255, 255)"
                                  d="M19.720,8.688 C19.317,9.091 18.664,9.091 18.260,8.688 L10.016,2.286 L1.771,8.688 C1.367,9.091 0.714,9.091 0.311,8.688 C-0.092,8.285 -0.092,7.631 0.311,7.228 L9.259,0.279 C9.468,0.071 9.743,-0.025 10.016,-0.018 C10.289,-0.025 10.563,0.071 10.772,0.279 L19.720,7.228 C20.123,7.631 20.123,8.285 19.720,8.688 ZM4.000,8.000 C4.552,8.000 5.000,8.448 5.000,9.000 L5.000,15.000 L7.000,15.000 L7.000,10.000 C7.000,9.448 7.448,9.000 8.000,9.000 L12.000,9.000 C12.552,9.000 13.000,9.448 13.000,10.000 L13.000,15.000 L15.000,15.000 L15.000,9.000 C15.000,8.448 15.448,8.000 16.000,8.000 C16.552,8.000 17.000,8.448 17.000,9.000 L17.000,16.000 C17.000,16.552 16.552,17.000 16.000,17.000 L4.000,17.000 C3.448,17.000 3.000,16.552 3.000,16.000 L3.000,9.000 C3.000,8.448 3.448,8.000 4.000,8.000 ZM11.000,15.000 L11.000,11.000 L9.000,11.000 L9.000,15.000 L11.000,15.000 Z" />
                        </svg>
                        首页
                    </router-link>
                    <router-link to="/search"
                                 class="btnNav btnGame"
                                 :class="{'active': routeName === 2}"
                                 @click="fnNavClick(1, '游戏')">
                        <svg xmlns="http://www.w3.org/2000/svg"
                             xmlns:xlink="http://www.w3.org/1999/xlink"
                             width="26px"
                             height="16px">
                            <path fill-rule="evenodd"
                                  fill="rgb(170, 170, 170)"
                                  d="M24.000,16.000 L2.000,16.000 C0.895,16.000 -0.000,15.105 -0.000,14.000 L-0.000,2.000 C-0.000,0.895 0.895,-0.000 2.000,-0.000 L24.000,-0.000 C25.104,-0.000 26.000,0.895 26.000,2.000 L26.000,14.000 C26.000,15.105 25.104,16.000 24.000,16.000 ZM24.000,4.000 C24.000,2.895 23.105,2.000 22.000,2.000 L4.000,2.000 C2.895,2.000 2.000,2.895 2.000,4.000 L2.000,12.000 C2.000,13.105 2.895,14.000 4.000,14.000 L22.000,14.000 C23.105,14.000 24.000,13.105 24.000,12.000 L24.000,4.000 ZM20.000,8.000 C18.895,8.000 18.000,7.105 18.000,6.000 C18.000,4.895 18.895,4.000 20.000,4.000 C21.105,4.000 22.000,4.895 22.000,6.000 C22.000,7.105 21.105,8.000 20.000,8.000 ZM16.000,12.000 C14.895,12.000 14.000,11.105 14.000,10.000 C14.000,8.895 14.895,8.000 16.000,8.000 C17.104,8.000 18.000,8.895 18.000,10.000 C18.000,11.105 17.104,12.000 16.000,12.000 ZM11.000,9.000 L9.000,9.000 L9.000,11.000 C9.000,11.552 8.552,12.000 8.000,12.000 C7.448,12.000 7.000,11.552 7.000,11.000 L7.000,9.000 L5.000,9.000 C4.448,9.000 4.000,8.552 4.000,8.000 C4.000,7.448 4.448,7.000 5.000,7.000 L7.000,7.000 L7.000,5.000 C7.000,4.448 7.448,4.000 8.000,4.000 C8.552,4.000 9.000,4.448 9.000,5.000 L9.000,7.000 L11.000,7.000 C11.552,7.000 12.000,7.448 12.000,8.000 C12.000,8.552 11.552,9.000 11.000,9.000 Z" />
                        </svg>
                        游戏
                    </router-link>
                    <router-link to="/gifts"
                                 class="btnNav btnCharge"
                                 :class="{'active': routeName === 3}"
                                 @click="fnNavClick(1, '福利')">
                        <svg xmlns="http://www.w3.org/2000/svg"
                             xmlns:xlink="http://www.w3.org/1999/xlink"
                             width="20px"
                             height="20px">
                            <path fill-rule="evenodd"
                                  fill="rgb(170, 170, 170)"
                                  d="M19.000,10.000 L18.000,10.000 L18.000,19.000 C18.000,19.552 17.552,20.000 17.000,20.000 L3.000,20.000 C2.448,20.000 2.000,19.552 2.000,19.000 L2.000,10.000 L1.000,10.000 C0.448,10.000 -0.000,9.552 -0.000,9.000 L-0.000,5.000 C-0.000,4.448 0.448,4.000 1.000,4.000 L4.050,4.000 C4.027,3.835 4.000,3.671 4.000,3.500 C4.000,1.567 5.567,-0.000 7.500,-0.000 C8.481,-0.000 9.365,0.406 10.000,1.056 C10.635,0.406 11.519,-0.000 12.500,-0.000 C14.433,-0.000 16.000,1.567 16.000,3.500 C16.000,3.671 15.973,3.835 15.950,4.000 L19.000,4.000 C19.552,4.000 20.000,4.448 20.000,5.000 L20.000,9.000 C20.000,9.552 19.552,10.000 19.000,10.000 ZM15.000,18.000 C15.552,18.000 16.000,17.552 16.000,17.000 L16.000,10.000 L11.000,10.000 L11.000,18.000 L15.000,18.000 ZM4.000,17.000 C4.000,17.552 4.448,18.000 5.000,18.000 L9.000,18.000 L9.000,10.000 L4.000,10.000 L4.000,17.000 ZM7.500,2.000 C6.672,2.000 6.000,2.672 6.000,3.500 C6.000,3.676 6.036,3.843 6.092,4.000 L8.908,4.000 C8.964,3.843 9.000,3.676 9.000,3.500 C9.000,2.672 8.328,2.000 7.500,2.000 ZM3.000,6.000 C2.448,6.000 2.000,6.448 2.000,7.000 C2.000,7.552 2.448,8.000 3.000,8.000 L9.000,8.000 L9.000,6.000 L3.000,6.000 ZM12.500,2.000 C11.672,2.000 11.000,2.672 11.000,3.500 C11.000,3.676 11.036,3.843 11.092,4.000 L13.908,4.000 C13.964,3.843 14.000,3.676 14.000,3.500 C14.000,2.672 13.328,2.000 12.500,2.000 ZM17.000,6.000 L11.000,6.000 L11.000,8.000 L17.000,8.000 C17.552,8.000 18.000,7.552 18.000,7.000 C18.000,6.448 17.552,6.000 17.000,6.000 Z" />
                        </svg>
                        福利
                        <svg xmlns="http://www.w3.org/2000/svg"
                             xmlns:xlink="http://www.w3.org/1999/xlink"
                             width="23px"
                             height="13px"
                             style="position: absolute;top:-6px;right:3px"
                             v-if="routeName != 3">
                            <image x="0px"
                                   y="0px"
                                   width="23px"
                                   height="13px"
                                   xlink:href="data:img/png;base64,iVBORw0KGgoAAAANSUhEUgAAABcAAAANCAMAAAB1uQVvAAAABGdBTUEAALGPC/xhBQAAACBjSFJNAAB6JgAAgIQAAPoAAACA6AAAdTAAAOpgAAA6mAAAF3CculE8AAAAWlBMVEXhaEvhaEvhaEvhaEvhaEvhaEvhaEvhaEvhaEvhaEvhaEvhaEv77erjc1j20cn99vT////0yb7ywLPib1PzwLT99/XjclfjdFrjcFT0yb/21Mv++vn31MzjdFnVnkbKAAAAC3RSTlMASebnSuTwHu5NDEnP3RcAAAABYktHRBCVsg0sAAAAB3RJTUUH5AwECi8DjRFlYwAAAGVJREFUGNN1zkkOgCAQBMBhcR1AQHH3/98UCBfi2EmTdHEAYBy/4QwojhcQD5WrzWQ0Kmtt2sltrvPz4soqnoJhxS3Unvvnzu/+qLy8e173U1Z0+p8CpCC4kRCDbQdU+oFkGAl7ASBECw1VqQDKAAAAAElFTkSuQmCC" />
                        </svg>
                    </router-link>
                </div>
                <div class="search">
                    <div class="searchInner">
                        <input type="text"
                               placeholder="唐门六道3D"
                               class="ipt iptSearch"
                               spellcheck="false"
                               @keyup.enter="fnBtnClick('search')"
                               v-model="inputValueSearch"
                               maxlength="45" />
                        <a href="javascript:;"
                           class="btnSearch"
                           @click="fnBtnClick('search')"></a>
                    </div>
                </div>
                <div class="r">
                    <a href="javascript:;"
                       class="btnActivity btnPrivilege btnNetFee"
                       @click="fnShowContentBrowser"
                       v-if="ADSHALLDATA.image_url">
                        <span>
                            <img :src="ADSHALLDATA.image_url"
                                 :alt="ADSHALLDATA.title" />
                        </span>
                    </a>
                    <!-- 去掉盒子特权入口 -->
                    <!-- <a href="javascript:;"
                       class="btnActivity btnPrivilege"
                       @click="fnBtnClick('privilege')">
                        <span>
                            <img src="/resource/images/img_32x32.png"
                                 alt="盒子特权" />
                        </span>
                        <span :class="{'coloree9b00': isLogined}">盒子特权</span>
                        <svg xmlns="http://www.w3.org/2000/svg"
                             xmlns:xlink="http://www.w3.org/1999/xlink"
                             width="61.5px"
                             height="27.5px"
                             class="svgPrivilege"
                             v-if="!isLogined">
                            <path fill-rule="evenodd"
                                  stroke="rgb(221, 221, 221)"
                                  stroke-width="1px"
                                  stroke-linecap="butt"
                                  stroke-linejoin="miter"
                                  fill="none"
                                  d="M56.500,20.500 L5.900,20.500 L0.500,26.500 L0.500,16.500 L0.500,4.500 C0.500,2.291 2.291,0.500 4.500,0.500 L56.500,0.500 C58.709,0.500 60.500,2.291 60.500,4.500 L60.500,16.500 C60.500,18.709 58.709,20.500 56.500,20.500 Z" />
                            <text kerning="auto"
                                  font-family="Adobe Heiti Std"
                                  fill="rgb(0, 0, 0)"
                                  font-size="12px"
                                  x="6.5px"
                                  y="14.5px">
                                <tspan font-size="12px"
                                       font-family="Microsoft YaHei"
                                       fill="#888888">&#30331;&#24405;&#28608;&#27963;</tspan>
                            </text>
                        </svg>
                        <svg xmlns="http://www.w3.org/2000/svg"
                             xmlns:xlink="http://www.w3.org/1999/xlink"
                             width="51.5px"
                             height="27.5px"
                             class="svgPrivilege"
                             v-else>
                            <path fill-rule="evenodd"
                                  stroke="rgb(255, 193, 108)"
                                  stroke-width="1px"
                                  stroke-linecap="butt"
                                  stroke-linejoin="miter"
                                  fill="none"
                                  d="M46.500,20.500 L5.900,20.500 L0.500,26.500 L0.500,16.500 L0.500,4.500 C0.500,2.291 2.291,0.500 4.500,0.500 L46.500,0.500 C48.709,0.500 50.500,2.291 50.500,4.500 L50.500,16.500 C50.500,18.709 48.709,20.500 46.500,20.500 Z" />
                            <text kerning="auto"
                                  font-family="Adobe Heiti Std"
                                  fill="rgb(0, 0, 0)"
                                  font-size="12px"
                                  x="7.5px"
                                  y="14.5px">
                                <tspan font-size="12px"
                                       font-family="Microsoft YaHei"
                                       fill="#FFC16C">&#24050;&#28608;&#27963;</tspan>
                            </text>
                        </svg>
                    </a> -->
                    <a href="javascript:;"
                       class="userInfoWraper"
                       v-if="isLogined">
                        <span>
                            <img :src="USER.logoPath"
                                 :alt="USER.displayPassport"
                                 class="avatar" />
                        </span>
                        <div class="userInfo"
                             v-if="USER">
                            <div class="item btnUserInfo">
                                <img :src="USER.logoPath"
                                     :alt="USER.displayPassport"
                                     class="img avatar" />
                                <div class="txt"
                                     v-text="USER.isVistor?'游客':USER.displayPassport"></div>
                            </div>
                            <div class="item btnUserCenter"
                                 @click="fnBtnClick('userCenter')">
                                <svg xmlns="http://www.w3.org/2000/svg"
                                     xmlns:xlink="http://www.w3.org/1999/xlink"
                                     width="21px"
                                     height="23px"
                                     class="img">
                                    <path fill-rule="evenodd"
                                          fill="rgb(170, 170, 170)"
                                          d="M19.000,23.000 C19.000,23.000 19.000,21.370 19.000,20.500 C19.000,17.519 17.463,14.901 15.141,13.384 C13.864,14.393 12.254,15.000 10.500,15.000 C8.746,15.000 7.136,14.393 5.859,13.384 C3.537,14.901 2.000,17.519 2.000,20.500 C2.000,21.370 2.000,23.000 2.000,23.000 L-0.000,23.000 C-0.000,23.000 -0.000,21.363 -0.000,20.500 C-0.000,16.954 1.762,13.826 4.454,11.924 C3.544,10.683 3.000,9.157 3.000,7.500 C3.000,3.358 6.358,-0.000 10.500,-0.000 C14.642,-0.000 18.000,3.358 18.000,7.500 C18.000,9.157 17.456,10.683 16.546,11.924 C19.237,13.826 21.000,16.954 21.000,20.500 C21.000,21.363 21.000,23.000 21.000,23.000 L19.000,23.000 ZM10.500,2.000 C7.462,2.000 5.000,4.462 5.000,7.500 C5.000,7.847 5.038,8.184 5.102,8.512 C5.136,8.696 5.196,8.870 5.248,9.048 C5.285,9.170 5.316,9.296 5.362,9.415 C5.450,9.652 5.560,9.875 5.679,10.095 C5.700,10.134 5.719,10.173 5.741,10.211 C5.884,10.460 6.043,10.694 6.221,10.917 C6.221,10.917 6.221,10.917 6.221,10.917 L6.221,10.917 C6.705,11.522 7.308,12.017 8.003,12.374 L8.003,12.374 L8.003,12.374 C8.247,12.500 8.500,12.605 8.765,12.694 C8.920,12.748 9.077,12.800 9.238,12.841 C9.351,12.867 9.465,12.888 9.581,12.907 C9.880,12.962 10.184,13.000 10.500,13.000 C10.815,13.000 11.120,12.962 11.419,12.907 C11.535,12.888 11.648,12.867 11.762,12.841 C11.923,12.800 12.079,12.748 12.235,12.694 C12.499,12.605 12.752,12.500 12.997,12.374 C12.997,12.374 12.997,12.374 12.997,12.374 L12.997,12.374 C13.948,11.886 14.730,11.136 15.258,10.211 C15.280,10.173 15.300,10.134 15.321,10.095 C15.440,9.875 15.549,9.652 15.638,9.415 C15.684,9.296 15.714,9.170 15.752,9.048 C15.804,8.870 15.863,8.696 15.898,8.512 C15.961,8.184 16.000,7.847 16.000,7.500 C16.000,4.462 13.537,2.000 10.500,2.000 Z" />
                                </svg>
                                <div class="txt">个人中心</div>
                            </div>
                            <div class="item btnMsg"
                                 @click="fnBtnClick('wndUserMsg')">
                                <svg xmlns="http://www.w3.org/2000/svg"
                                     xmlns:xlink="http://www.w3.org/1999/xlink"
                                     width="21px"
                                     height="22px"
                                     class="img">
                                    <path fill-rule="evenodd"
                                          fill="rgb(170, 170, 170)"
                                          d="M17.000,8.500 C17.000,9.328 16.328,10.000 15.500,10.000 C14.671,10.000 14.000,9.328 14.000,8.500 C14.000,7.672 14.671,7.000 15.500,7.000 C16.328,7.000 17.000,7.672 17.000,8.500 ZM12.000,8.500 C12.000,9.328 11.328,10.000 10.500,10.000 C9.671,10.000 9.000,9.328 9.000,8.500 C9.000,7.672 9.671,7.000 10.500,7.000 C11.328,7.000 12.000,7.672 12.000,8.500 ZM4.000,8.500 C4.000,7.672 4.671,7.000 5.500,7.000 C6.328,7.000 7.000,7.672 7.000,8.500 C7.000,9.328 6.328,10.000 5.500,10.000 C4.671,10.000 4.000,9.328 4.000,8.500 ZM19.000,17.000 L11.469,17.000 L7.765,20.704 C7.359,21.110 6.702,21.110 6.296,20.704 C5.890,20.298 5.890,19.640 6.296,19.235 L10.235,15.296 C10.448,15.082 10.732,14.988 11.012,15.000 L17.000,15.000 C18.104,15.000 19.000,14.105 19.000,13.000 L19.000,4.000 C19.000,2.895 18.104,2.000 17.000,2.000 L4.000,2.000 C2.895,2.000 2.000,2.895 2.000,4.000 L2.000,13.000 C2.000,14.105 2.895,15.000 4.000,15.000 L5.000,15.000 C5.552,15.000 6.000,15.448 6.000,16.000 C6.000,16.552 5.552,17.000 5.000,17.000 L2.000,17.000 C0.895,17.000 -0.000,16.105 -0.000,15.000 L-0.000,2.000 C-0.000,0.895 0.895,-0.000 2.000,-0.000 L19.000,-0.000 C20.104,-0.000 21.000,0.895 21.000,2.000 L21.000,15.000 C21.000,16.105 20.104,17.000 19.000,17.000 Z" />
                                </svg>
                                <div class="txt">消息</div>
                            </div>
                            <div class="item btnSwitchAccount"
                                 @click="fnBtnClick('wndSwitchAccount')">
                                <svg xmlns="http://www.w3.org/2000/svg"
                                     xmlns:xlink="http://www.w3.org/1999/xlink"
                                     width="21px"
                                     height="21px"
                                     class="img">
                                    <path fill-rule="evenodd"
                                          fill="rgb(170, 170, 170)"
                                          d="M10.500,21.000 C4.701,21.000 -0.000,16.299 -0.000,10.500 C-0.000,4.701 4.701,-0.000 10.500,-0.000 C16.299,-0.000 21.000,4.701 21.000,10.500 C21.000,16.299 16.299,21.000 10.500,21.000 ZM10.500,2.000 C5.805,2.000 2.000,5.806 2.000,10.500 C2.000,15.194 5.805,19.000 10.500,19.000 C15.194,19.000 19.000,15.194 19.000,10.500 C19.000,5.806 15.194,2.000 10.500,2.000 ZM16.005,13.000 L7.535,13.000 L9.687,15.146 C10.109,15.567 10.109,16.251 9.687,16.672 C9.264,17.093 8.579,17.093 8.157,16.672 L4.331,12.857 C4.097,12.623 4.006,12.311 4.031,12.007 C4.031,12.006 4.031,12.006 4.031,12.005 L4.031,11.995 C4.031,11.445 4.477,11.000 5.026,11.000 L16.005,11.000 C16.555,11.000 17.000,11.445 17.000,11.995 L17.000,12.005 C17.000,12.555 16.555,13.000 16.005,13.000 ZM16.000,10.000 L5.000,10.000 C4.448,10.000 4.000,9.552 4.000,9.000 C4.000,8.448 4.448,8.000 5.000,8.000 L13.497,8.000 L11.330,5.832 C10.906,5.409 10.906,4.722 11.330,4.298 C11.753,3.875 12.440,3.875 12.864,4.298 L16.699,8.134 C16.935,8.369 17.025,8.685 16.999,8.993 C16.999,8.995 17.000,8.998 17.000,9.000 C17.000,9.552 16.552,10.000 16.000,10.000 Z" />
                                </svg>
                                <div class="txt">切换账号</div>
                            </div>
                        </div>
                    </a>
                    <a href="javascript:;"
                       v-else>
                        <span @click="fnBtnClick('wndLogin')">&nbsp;&nbsp;&nbsp;&nbsp;登录&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</span>
                    </a>
                    <span class="spaceLine"></span>
                    <a class="btnWnd btnWndSetting"
                       href="javascript:;"
                       @click="fnBtnClick('settings')">
                        <svg xmlns="http://www.w3.org/2000/svg"
                             xmlns:xlink="http://www.w3.org/1999/xlink"
                             width="10px"
                             height="9px">
                            <path fill-rule="evenodd"
                                  fill="rgb(136, 136, 136)"
                                  d="M9.000,5.000 L9.000,6.000 L8.000,6.000 L8.000,7.000 L7.000,7.000 L7.000,8.000 L6.000,8.000 L6.000,9.000 L4.000,9.000 L4.000,8.000 L3.000,8.000 L3.000,7.000 L2.000,7.000 L2.000,6.000 L1.000,6.000 L1.000,5.000 L-0.000,5.000 L-0.000,4.000 L10.000,4.000 L10.000,5.000 L9.000,5.000 ZM-0.000,-0.000 L10.000,-0.000 L10.000,2.000 L-0.000,2.000 L-0.000,-0.000 Z" />
                        </svg>
                    </a>
                    <client-wnd-tool @fnBtnClick="fnBtnClick"></client-wnd-tool>
                </div>
            </div>
        </div>
        <div class="settingWraper"
             v-if="settings">
            <div class="settingMask"
                 @click="fnBtnClick('settings')"></div>
            <div class="settings">
                <a href="javascript:;"
                   class="btnSysSetting"
                   @click="fnBtnClick('wndSetting')">系统设置</a>
                <a href="javascript:;"
                   class="btnCheckBoxUpdate"
                   @click="fnBtnClick('checkUpdate')">检测更新</a>
                <a href="javascript:;"
                   class="btnFaq"
                   @click="fnBtnClick('wndFaq')">常见问题</a>
                <a href="javascript:;"
                   class="btnViewMore">
                    更多
                    <span>
                        <svg xmlns="http://www.w3.org/2000/svg"
                             xmlns:xlink="http://www.w3.org/1999/xlink"
                             width="7px"
                             height="13px">
                            <path fill-rule="evenodd"
                                  fill="rgb(136, 136, 136)"
                                  d="M7.015,6.738 L0.739,13.015 L-0.015,12.261 L5.750,6.496 L0.016,0.762 L0.762,0.016 L6.984,6.238 L6.749,6.472 L7.015,6.738 Z" />
                        </svg>
                    </span>
                    <div class="subInfo">
                        <a href="javascript:;"
                           @click="fnBtnClick('openService')">客服中心</a>
                        <a href="javascript:;"
                           @click="fnBtnClick('openOfficial')">易乐玩游戏</a>
                        <a href="javascript:;"
                           @click="fnBtnClick('aboutUs')">关于我们</a>
                    </div>
                </a>
                <a href="javascript:;"
                   class="btnLogout"
                   @click="fnLogout">
                    <svg xmlns="http://www.w3.org/2000/svg"
                         xmlns:xlink="http://www.w3.org/1999/xlink"
                         width="13px"
                         height="11px">
                        <path fill-rule="evenodd"
                              fill="rgb(253, 148, 43)"
                              d="M11.973,5.538 C11.971,5.579 11.982,5.621 11.967,5.665 C11.960,5.684 11.953,5.701 11.944,5.719 C11.922,5.765 11.925,5.818 11.887,5.856 C11.860,5.883 11.821,5.877 11.789,5.897 C11.785,5.900 11.779,5.900 11.774,5.903 L7.791,9.886 C7.604,10.073 7.301,10.073 7.114,9.886 C6.927,9.699 6.927,9.396 7.114,9.209 L10.323,6.000 L3.500,6.000 C3.224,6.000 3.000,5.776 3.000,5.500 C3.000,5.224 3.224,5.000 3.500,5.000 L10.354,5.000 L7.145,1.791 C6.958,1.604 6.958,1.301 7.145,1.114 C7.332,0.927 7.635,0.927 7.823,1.114 L11.850,5.141 C11.852,5.143 11.854,5.142 11.856,5.144 C11.858,5.146 11.857,5.148 11.859,5.150 L11.887,5.179 C11.900,5.192 11.896,5.211 11.907,5.225 C11.943,5.279 11.967,5.338 11.980,5.403 C11.984,5.416 11.976,5.427 11.979,5.440 C11.982,5.475 11.978,5.503 11.973,5.538 ZM4.500,1.000 L1.000,1.000 L1.000,10.000 L4.500,10.000 C4.776,10.000 5.000,10.224 5.000,10.500 C5.000,10.776 4.776,11.000 4.500,11.000 L0.500,11.000 C0.224,11.000 -0.000,10.776 -0.000,10.500 L-0.000,0.500 C-0.000,0.224 0.224,-0.000 0.500,-0.000 L4.500,-0.000 C4.776,-0.000 5.000,0.224 5.000,0.500 C5.000,0.776 4.776,1.000 4.500,1.000 Z" />
                    </svg>退出
                </a>
            </div>
        </div>
        <!--特权-->
        <wnd-privilege @fnBtnClick="fnBtnClick"
                       v-if="wndPrivilegeJudge" />
        <!--设置-->
        <modal-slot :data="wndSettingData"
                    @fnBtnClick="fnBtnClick"
                    v-if="wndSetting">
            <div class="settingWraper">
                <div class="settingPanel">
                    <div class="item item-1">
                        <div class="dt">启动设置：</div>
                        <div class="dd">
                            <label>
                                <input type="checkbox"
                                       v-model="sysConfig.setAsAutoRun" />
                                <div v-if="!sysConfig.setAsAutoRun">
                                    <svg xmlns="http://www.w3.org/2000/svg"
                                         xmlns:xlink="http://www.w3.org/1999/xlink"
                                         width="17px"
                                         height="17px">
                                        <path fill-rule="evenodd"
                                              stroke="rgb(187, 187, 187)"
                                              stroke-width="1px"
                                              stroke-linecap="butt"
                                              stroke-linejoin="miter"
                                              fill="rgb(255, 255, 255)"
                                              d="M0.500,0.500 L16.500,0.500 L16.500,16.500 L0.500,16.500 L0.500,0.500 Z" />
                                    </svg>
                                </div>
                                <div v-else>
                                    <svg xmlns="http://www.w3.org/2000/svg"
                                         xmlns:xlink="http://www.w3.org/1999/xlink"
                                         width="17px"
                                         height="17px">
                                        <path fill-rule="evenodd"
                                              stroke="rgb(187, 187, 187)"
                                              stroke-width="1px"
                                              stroke-linecap="butt"
                                              stroke-linejoin="miter"
                                              fill="rgb(255, 255, 255)"
                                              d="M0.500,0.500 L16.500,0.500 L16.500,16.500 L0.500,16.500 L0.500,0.500 Z" />
                                        <path fill-rule="evenodd"
                                              fill="rgb(252, 157, 39)"
                                              d="M14.493,6.005 L7.838,13.492 L7.524,13.138 L7.165,13.496 L3.503,9.834 L4.834,8.503 L7.363,11.031 L13.162,4.507 L14.493,6.005 Z" />
                                    </svg>
                                </div>&nbsp;开机自动启动
                            </label>
                        </div>
                    </div>
                    <div class="item item-2">
                        <div class="dt">关闭功能：</div>
                        <div class="dd">
                            <label>
                                <input type="radio"
                                       name="features"
                                       v-model="sysConfig.closeType"
                                       :value="0" />
                                <span>隐藏到托盘</span>
                            </label>
                            <label>
                                <input type="radio"
                                       name="features"
                                       v-model="sysConfig.closeType"
                                       :value="1" />
                                <span>退出客户端</span>
                            </label>
                        </div>
                    </div>
                    <div class="item item-4">
                        <div class="dt">检测更新：</div>
                        <div class="dd">
                            <label>
                                <input type="radio"
                                       name="checkUpdate"
                                       v-model="sysConfig.updateType"
                                       :value="0" />
                                <span>自动检测</span>
                            </label>
                            <label>
                                <input type="radio"
                                       name="checkUpdate"
                                       v-model="sysConfig.updateType"
                                       :value="1" />
                                <span>不自动检测</span>
                            </label>
                        </div>
                    </div>
                </div>
                <div class="btnGroup">
                    <a href="javascript:;"
                       class="btnNml btnSave"
                       @click="fnBtnClick('saveSetting')">保存设置</a>
                    <a href="javascript:;"
                       class="btnBorder btnCancel"
                       @click="wndSetting = false">取消</a>
                </div>
            </div>
        </modal-slot>
        <!--升级-->
        <modal-slot :data="wndCheckUpdateData"
                    @fnBtnClick="fnBtnClick"
                    v-if="wndCheckUpdate">
            <div class="info">
                <div class="group group-1"
                     v-if="checkUpdating">
                    <div class="clearing"></div>
                    <div class="txt">升级中</div>
                </div>
                <div class="group group-2"
                     v-else>
                    <div class="img imgChecking"
                         v-if="checkingUpdate">
                        <svg xmlns="http://www.w3.org/2000/svg"
                             xmlns:xlink="http://www.w3.org/1999/xlink"
                             width="19px"
                             height="20px">
                            <path fill-rule="evenodd"
                                  fill="rgb(255, 255, 255)"
                                  d="M1.774,0.850 L18.087,16.147 C18.860,16.936 18.847,18.203 18.058,18.976 C17.269,19.749 16.003,19.736 15.230,18.947 L0.345,2.251 L1.774,0.850 Z" />
                        </svg>
                    </div>
                    <div class="img imgDone"
                         v-if="checkUpdateDone">
                        <svg xmlns="http://www.w3.org/2000/svg"
                             xmlns:xlink="http://www.w3.org/1999/xlink"
                             width="6px"
                             height="35px">
                            <path fill-rule="evenodd"
                                  fill="rgb(255, 255, 255)"
                                  d="M3.000,35.000 C1.343,35.000 -0.000,33.657 -0.000,32.000 C-0.000,30.343 1.343,29.000 3.000,29.000 C4.657,29.000 6.000,30.343 6.000,32.000 C6.000,33.657 4.657,35.000 3.000,35.000 ZM3.000,26.000 C1.895,26.000 1.000,25.104 1.000,24.000 L1.000,2.000 C1.000,0.895 1.895,-0.000 3.000,-0.000 C4.105,-0.000 5.000,0.895 5.000,2.000 L5.000,24.000 C5.000,25.104 4.105,26.000 3.000,26.000 Z" />
                        </svg>
                    </div>
                    <div class="img imgError"
                         v-if="checkUpdatingError">
                        <svg xmlns="http://www.w3.org/2000/svg"
                             xmlns:xlink="http://www.w3.org/1999/xlink"
                             width="31px"
                             height="31px">
                            <path fill-rule="evenodd"
                                  fill="rgb(255, 255, 255)"
                                  d="M30.349,4.186 L18.328,16.207 L29.642,27.520 C30.423,28.301 30.423,29.568 29.642,30.349 C28.861,31.129 27.595,31.129 26.814,30.349 L15.500,19.035 L4.186,30.349 C3.405,31.129 2.139,31.129 1.358,30.349 C0.577,29.568 0.577,28.301 1.358,27.520 L12.672,16.207 L0.651,4.186 C-0.130,3.405 -0.130,2.138 0.651,1.357 C1.432,0.576 2.698,0.576 3.479,1.357 L15.500,13.378 L27.521,1.357 C28.302,0.576 29.568,0.576 30.349,1.357 C31.130,2.138 31.130,3.405 30.349,4.186 Z" />
                        </svg>
                    </div>
                    <div class="txt">{{txtUpdating}}</div>
                </div>
            </div>
            <div class="btnGroup">
                <a href="javascript:;"
                   class="btnNml btnSave"
                   @click="!checkUpdateDone"
                   v-if="checkUpdatingError">重试</a>
                <a href="javascript:;"
                   class="btnBorder btnCancel"
                   @click="wndCheckUpdate = false">取消</a>
            </div>
        </modal-slot>
        <!--关于我们-->
        <modal-slot :data="wndAboutUsData"
                    @fnBtnClick="fnBtnClick"
                    v-if="wndAboutUs">
            <div class="aboutUsWraper">
                <div class="img">
                    <img src="/resource/images/logo_aboutus.png"
                         alt="易乐玩游戏盒子" />
                </div>
                <div class="version">
                    <span class="btnNml"
                          v-text="clientVersion"></span>
                </div>
                <div class="siteAddress">www.yilewan.com</div>
                <div class="copy">湖北盛天网络技术股份有限公司 版权所有</div>
            </div>
        </modal-slot>
        <!--退出-->
        <modal-slot :data="wndCloseData"
                    @fnBtnClick="fnBtnClick"
                    v-if="wndClose">
            <div class="info">
                <div class="img"
                     v-if="hasGameWnd">
                    <svg xmlns="http://www.w3.org/2000/svg"
                         xmlns:xlink="http://www.w3.org/1999/xlink"
                         width="6px"
                         height="35px">
                        <path fill-rule="evenodd"
                              fill="rgb(255, 255, 255)"
                              d="M3.000,35.000 C1.343,35.000 -0.000,33.657 -0.000,32.000 C-0.000,30.342 1.343,28.999 3.000,28.999 C4.657,28.999 6.000,30.342 6.000,32.000 C6.000,33.657 4.657,35.000 3.000,35.000 ZM3.000,26.000 C1.895,26.000 1.000,25.104 1.000,24.000 L1.000,1.999 C1.000,0.895 1.895,-0.000 3.000,-0.000 C4.105,-0.000 5.000,0.895 5.000,1.999 L5.000,24.000 C5.000,25.104 4.105,26.000 3.000,26.000 Z" />
                    </svg>
                </div>
                <div class="img"
                     v-else>
                    <svg xmlns="http://www.w3.org/2000/svg"
                         xmlns:xlink="http://www.w3.org/1999/xlink"
                         width="20px"
                         height="37px">
                        <path fill-rule="evenodd"
                              fill="rgb(255, 255, 255)"
                              d="M18.378,13.181 C12.003,19.089 12.255,20.780 12.255,20.780 L12.255,23.820 C12.255,23.820 12.255,25.846 10.215,25.846 C8.174,25.846 8.174,23.820 8.174,23.820 C8.174,23.804 8.174,23.567 8.174,20.780 C8.174,17.596 10.215,15.715 10.215,15.715 C10.215,15.715 15.535,11.517 15.827,9.635 C16.381,6.059 14.150,3.556 10.215,3.556 C6.279,3.556 4.093,6.306 4.093,8.622 C4.093,10.938 2.562,11.155 2.562,11.155 C0.448,11.662 0.011,9.128 0.011,9.128 C0.011,9.128 0.740,0.010 10.215,0.010 C19.689,0.010 19.908,8.116 19.908,8.116 C19.908,8.116 20.564,11.155 18.378,13.181 ZM10.203,30.937 C11.886,30.937 13.250,32.294 13.250,33.968 C13.250,35.642 11.886,37.000 10.203,37.000 C8.520,37.000 7.156,35.642 7.156,33.968 C7.156,32.294 8.520,30.937 10.203,30.937 Z" />
                    </svg>
                </div>
                <div class="txt">{{txtClose}}</div>
            </div>
            <div class="btnGroup">
                <a href="javascript:;"
                   class="btnNml btnSave"
                   @click="fnBtnClick('exitClient')">确定</a>
                <a href="javascript:;"
                   class="btnBorder btnCancel"
                   @click="wndClose = false">取消</a>
            </div>
        </modal-slot>
        <!--切换账号-->
        <modal-slot :data="wndSwitchAccountData"
                    @fnBtnClick="fnBtnClick"
                    v-if="wndSwitchAccount">
            <div class="info">
                <div class="img">
                    <svg xmlns="http://www.w3.org/2000/svg"
                         xmlns:xlink="http://www.w3.org/1999/xlink"
                         width="20px"
                         height="37px">
                        <path fill-rule="evenodd"
                              fill="rgb(255, 255, 255)"
                              d="M18.378,13.181 C12.003,19.089 12.255,20.780 12.255,20.780 L12.255,23.820 C12.255,23.820 12.255,25.846 10.215,25.846 C8.174,25.846 8.174,23.820 8.174,23.820 C8.174,23.804 8.174,23.567 8.174,20.780 C8.174,17.596 10.215,15.715 10.215,15.715 C10.215,15.715 15.535,11.517 15.827,9.635 C16.381,6.059 14.150,3.556 10.215,3.556 C6.279,3.556 4.093,6.306 4.093,8.622 C4.093,10.938 2.562,11.155 2.562,11.155 C0.448,11.662 0.011,9.128 0.011,9.128 C0.011,9.128 0.740,0.010 10.215,0.010 C19.689,0.010 19.908,8.116 19.908,8.116 C19.908,8.116 20.564,11.155 18.378,13.181 ZM10.203,30.937 C11.886,30.937 13.250,32.294 13.250,33.968 C13.250,35.642 11.886,37.000 10.203,37.000 C8.520,37.000 7.156,35.642 7.156,33.968 C7.156,32.294 8.520,30.937 10.203,30.937 Z" />
                    </svg>
                </div>
                <div class="txt">{{wndSwitchAccountTxt}}</div>
            </div>
            <div class="btnGroup">
                <div class="tipsAgain">
                    <input type="checkbox"
                           v-model="wndSwitchAccountTipsAgain"
                           @change="fnTipsSwitchAccount" />
                    <div v-if="!wndSwitchAccountTipsAgain">
                        <svg xmlns="http://www.w3.org/2000/svg"
                             xmlns:xlink="http://www.w3.org/1999/xlink"
                             width="17px"
                             height="17px">
                            <path fill-rule="evenodd"
                                  stroke="rgb(187, 187, 187)"
                                  stroke-width="1px"
                                  stroke-linecap="butt"
                                  stroke-linejoin="miter"
                                  fill="rgb(255, 255, 255)"
                                  d="M0.500,0.500 L16.500,0.500 L16.500,16.500 L0.500,16.500 L0.500,0.500 Z" />
                        </svg>
                    </div>
                    <div v-else>
                        <svg xmlns="http://www.w3.org/2000/svg"
                             xmlns:xlink="http://www.w3.org/1999/xlink"
                             width="17px"
                             height="17px">
                            <path fill-rule="evenodd"
                                  stroke="rgb(187, 187, 187)"
                                  stroke-width="1px"
                                  stroke-linecap="butt"
                                  stroke-linejoin="miter"
                                  fill="rgb(255, 255, 255)"
                                  d="M0.500,0.500 L16.500,0.500 L16.500,16.500 L0.500,16.500 L0.500,0.500 Z" />
                            <path fill-rule="evenodd"
                                  fill="rgb(252, 157, 39)"
                                  d="M14.493,6.005 L7.838,13.492 L7.524,13.138 L7.165,13.496 L3.503,9.834 L4.834,8.503 L7.363,11.031 L13.162,4.507 L14.493,6.005 Z" />
                        </svg>
                    </div>&nbsp;不再提示
                </div>
                <a href="javascript:;"
                   class="btnNml btnSave"
                   @click="fnBtnClick('wndDoSwitchAccount')">确定</a>
                <a href="javascript:;"
                   class="btnBorder btnCancel"
                   @click="wndSwitchAccount = false">取消</a>
            </div>
        </modal-slot>
        <!--弹窗登录-->
        <div v-show="isfirstInstall">
            <modal-slot :data="wndLoginData"
                        @fnBtnClick="fnBtnClick"
                        v-if="wndLogin">
                <div style="text-align: center;margin-bottom: 27px;">
                    <img src="/resource/images/img_login_logo.png"
                         alt="易乐玩盒子" />
                </div>
                <div class="container">
                    <login :loginMethod="loginMethod"
                           @loginResult="fnLoginResult"></login>
                </div>
            </modal-slot>
        </div>
        <!--用户中心-->
        <modal-slot :data="wndUserCenterData"
                    @fnBtnClick="fnBtnClick"
                    v-if="wndUserCenter">
            <div class="userInfoWraper">
                <div class="top">
                    <div class="avatar">
                        <img :src="USER.logoPath"
                             :alt="USER.displayPassport" />
                    </div>
                    <div class="txt">
                        <div class="userName">昵称：<b v-text="USER.isVistor?'游客':USER.displayPassport"></b></div>
                        <div class="userId">账号：<b v-text="USER.isVistor?'游客':USER.passport"></b></div>
                    </div>
                    <a href="javascript:;"
                       class="btnUserDetail"
                       @click="fnBtnClick('userDetail')">
                        <svg xmlns="http://www.w3.org/2000/svg"
                             xmlns:xlink="http://www.w3.org/1999/xlink"
                             width="10px"
                             height="18px">
                            <path fill-rule="evenodd"
                                  fill="rgb(136, 136, 136)"
                                  d="M9.713,9.743 C9.609,9.847 9.486,9.915 9.356,9.961 L1.627,17.714 C1.257,18.086 0.656,18.086 0.285,17.714 C-0.086,17.342 -0.086,16.739 0.285,16.367 L7.627,9.002 L0.286,1.637 C-0.086,1.264 -0.086,0.660 0.286,0.286 C0.658,-0.087 1.261,-0.087 1.633,0.286 L9.462,8.140 C9.538,8.182 9.617,8.222 9.682,8.287 C9.797,8.402 9.863,8.541 9.907,8.686 C10.060,9.036 9.998,9.457 9.713,9.743 Z" />
                        </svg>
                    </a>
                </div>
                <div class="btm">
                    <div class="item item-1">
                        <div class="itemName">E豆</div>
                        <div class="colorfb674a itemVal"
                             v-text="userED"></div>
                    </div>
                    <div class="item item-2">
                        <div class="itemName">优惠券</div>
                        <div class="colorfb674a itemVal"
                             v-text="userEBQ"></div>
                    </div>
                </div>
            </div>
        </modal-slot>
        <!--常见问题-->
        <modal-slot :data="wndFaqData"
                    @fnBtnClick="fnBtnClick"
                    v-if="wndFaq">
            <div class="wndFaqWraper">
                <div class="item"
                     v-for="(item, index) in listDataFaq"
                     :key="item.category_id">
                    <div class="faqCategory">{{item.cateogry_name}}</div>
                    <div class="faqList">
                        <a href="javascript:;"
                           class="faqItem"
                           v-for="sub in listDataFaq[index].list"
                           :key="sub.id"
                           @click="fnShowFaqDetail(sub)">•&nbsp;&nbsp;{{sub.question}}</a>
                    </div>
                </div>
                <div class="faqItemDetail"
                     v-if="faqItemDetail">
                    <div class="faqBar">
                        <a href="javascript:;"
                           class="btnFaqBack"
                           @click="fnFaqBack">&lt; 返回</a>
                    </div>
                    <div class="faqItemTitle"
                         v-text="faqItemDetail.question"></div>
                    <div v-html="faqItemDetail.answer"></div>
                </div>
            </div>
        </modal-slot>
        <!--扫码充值-->
        <modal-slot :data="wndFaqData"
                    @fnBtnClick="fnBtnClick"
                    v-if="wndPay">
            <iframe src
                    frameborder="0"></iframe>
        </modal-slot>
    </div>
</template>

<script>
import store from '../store'
import ClientWndTool from './ClientWndTool'
import WndPrivilege from '@/components/WndPrivilege'
import Login from '@/login/index'
import ModalSlot from '@/components/ModalSlot'
export default {
    name: 'HeaderStyleA',
    props: {
        isfirstInstall: {
            type: Boolean,
            default: true
        }
    },
    data () {
        return {
            isLogined: store.state.USER.uid,
            USER: store.state.USER,
            userED: 0,
            userEBQ: '0 张',
            pageTitle: store.state.browserTitle || store.state.txt.appTitle,
            pageServerInfo: null,
            inputValueSearch: '唐门六道3D',
            wndPrivilegeJudge: false,
            settings: store.state.wnd.settings,
            wndSetting: false,
            wndSettingData: {
                title: '设置',
                style: {
                    width: '480px',
                    height: '300px',
                    marginLeft: '-240px',
                    marginTop: '-150px'
                },
                type: 'wndSetting'
            },
            wndCheckUpdate: false,
            wndCheckUpdateData: {
                title: '易乐玩游戏盒子升级',
                style: {
                    width: '480px',
                    height: '280px',
                    marginLeft: '-240px',
                    marginTop: '-140px'
                },
                type: 'wndCheckUpdate',
                class: 'wndCheckUpdate'
            },
            wndAboutUs: false,
            wndAboutUsData: {
                title: '关于我们',
                style: {
                    width: '300px',
                    height: '380px',
                    marginLeft: '-150px',
                    marginTop: '-190px'
                },
                type: 'wndAboutUs',
                class: 'modalAboutUs'
            },
            clientVersion: '',
            setAsAutoRun: true,
            closeType: 0,
            updateType: 0,
            browserUrl: null,
            wndPay: false,
            wndPayData: {
                title: '扫码充值',
                style: {
                    width: '698px',
                    height: '492px',
                    marginLeft: '-349px',
                    marginTop: '-246px'
                },
                type: 'wndPay',
                class: 'wndPay'
            },
            wndClose: false,
            wndCloseData: {
                title: '提示',
                style: {
                    width: '480px',
                    height: '260px',
                    marginLeft: '-240px',
                    marginTop: '-130px'
                },
                type: 'wndClose',
                class: 'wndClose'
            },
            txtClose: null,
            sysConfig: {
                closeType: store.state.sysConfig.closeType,
                setAsAutoRun: store.state.sysConfig.setAsAutoRun,
                updateType: store.state.sysConfig.updateType
            },
            hasGameWnd: false,
            isHall: false,
            txtUpdating: store.state.txt.checkUpdate,
            checkingUpdate: true,
            checkUpdating: false,
            checkUpdateDone: false,
            checkUpdatingError: false,
            wndSwitchAccount: false,
            wndSwitchAccountTipsAgain: false,
            wndSwitchAccountTxt: store.state.txt.switchAccount,
            wndSwitchAccountData: {
                title: '提示',
                style: {
                    width: '480px',
                    height: '160px',
                    marginLeft: '-240px',
                    marginTop: '-80px'
                },
                type: 'wndSwitchAccount',
                class: 'wndSwitchAccount'
            },
            wndDoSwitchAccount: false,
            userInfo: {
                avatar: '/img_avatar.png',
                displayPassport: '不吃猫的鱼'
            },
            wndLogin: false,
            wndLoginData: {
                title: '.',
                style: {
                    width: '400px',
                    height: '520px',
                    marginLeft: '-200px',
                    marginTop: '-260px'
                },
                visible: true,
                type: 'wndLogin',
                class: 'wndLogin'
            },
            thirdLoginUrl: null,
            wndLoginSrc: null,
            wndLoginUrl: '',
            wndThirdLogin: false,
            wndThirdLoginData: {
                title: '第三方账号登录',
                style: {
                    width: '760px',
                    height: '520px',
                    marginLeft: '-380px',
                    marginTop: '-260px'
                },
                type: 'wndThirdLogin',
                class: 'wndThirdLogin'
            },
            checkAgree: true,
            txtVerifyCode: '获取验证码',
            wndUserCenter: false,
            wndUserCenterData: {
                title: '用户中心',
                style: {
                    width: '520px',
                    height: '300px',
                    marginLeft: '-260px',
                    marginTop: '-150px'
                },
                type: 'wndUserCenter',
                class: 'wndUserCenter'
            },
            wndFaq: false,
            wndFaqData: {
                title: '常见问题',
                style: {
                    width: '500px',
                    height: '700px',
                    marginLeft: '-250px',
                    marginTop: '-350px'
                },
                type: 'wndFaq',
                class: 'wndFaq'
            },
            txtShowMsgDetail: 0,
            showMsgDetail: [true, true],
            boxConfig: false,
            btnNetFee: null,
            listDataFaq: [],
            faqItemDetail: null,
            ADSHALLDATA: {},
            routeName: 1,
            boxConfigData: null,
            btnFastClick: false,
            passiveLogin: false,
            gameparams: store.state.wndGameparams,
            gamegiftsparams: store.state.wndGameGiftsparams,
            gameVistorparams: store.state.wndGameVistorparams,
            loginMethod: 'normal',
            vistorTimer: null
        }
    },
    components: {
        WndPrivilege,
        ModalSlot,
        ClientWndTool,
        Login
    },
    computed: {
        wndGameparams () {
            return store.state.wndGameparams
        },
        wndGameGiftsparams () {
            return store.state.wndGameGiftsparams
        },
        wndGameVistorparams () {
            return store.state.wndGameVistorparams
        },
        isSettings () {
            return store.state.wnd.settings
        },
        isPageTitle () {
            return store.state.browserTitle
        },
        isLogin () {
            return store.state.showLogin
        },
        isRegister () {
            return store.state.showRegister
        },
        login () {
            return store.state.USER.uid
        },
        ADSHALL () {
            return store.state.ADSHALL
        },
        USER () {
            return store.state.USER
        },
        isVistor () {
            return store.state.isVistor
        }
    },
    watch: {
        wndGameparams (n, o) {
            if (n !== o) {
                this.gameparams = n
            }
        },
        wndGameGiftsparams (n, o) {
            if (n !== o) {
                this.gamegiftsparams = n
            }
        },
        wndGameVistorparams (n, o) {
            if (n !== o) {
                this.gameVistorparams = n
            }
        },
        isfirstInstall: {
            handler (n, o) {
                if (n !== o) {
                    this.isfirstInstall = n
                }
            },
            deep: true
        },
        isSettings (n, o) {
            if (n !== o) {
                this.settings = n
            }
        },
        isPageTitle (n, o) {
            if (n !== o) {
                this.pageTitle = n
                // this.log(this.pageTitle)
            }
        },
        isLogin (n, o) {
            if (n) {
                this.loginMethod = 'normal'
                this.wndLogin = true
            } else {
                this.wndLogin = false
            }
        },
        isRegister (n, o) {
            if (n) {
                this.loginMethod = 'register'
                this.wndLogin = true
            } else {
                this.wndLogin = false
            }
        },
        USER () {
            this.USER = store.state.USER
        },
        login (n, o) {
            this.fnIsLogined()
        },
        ADSHALL (n, o) {
            // console.log('ADSHALL->', n, o)
            if (n) {
                this.ADSHALLDATA = n.banner
            }
        },
        $route (e) {
            this.fnSwitchNavBg(e.name)
        },
        isVistor (n, o) {
            console.log('isvistor' + n)
            this.USER.isVistor = n
        }
    },
    mounted () {
        let t = this
        t.Storage.set('hasGameWnd', 0)
        // t.$message.info('This is a normal message')
        // 设置pid-cookies
        t.fnSetPidCookies()
        // 获取传入PID参数
        t.fnCefGameBox({
            method: 'GetCommandParams',
            success: res => {
                if (res && res.param) {
                    if (res.param.indexOf('--params=') > -1) {
                        // eslint-disable-next-line
                        let aaa = res.param.split(' --params=')[1].replace(/\"/gi, '').split('&')
                        let arr = {}
                        for (let i = 0; i < aaa.length; i++) {
                            let bbb = aaa[i].split('=')
                            arr[bbb[0]] = bbb[1]
                        }
                        t.Storage.get('floor' + arr.gamecode.toLowerCase(), res => {
                            if (res.data['floor' + arr.gamecode.toLowerCase()]) {
                                setTimeout(() => {
                                    t.Storage.del('floor' + arr.gamecode.toLowerCase())
                                }, 3000)
                                return
                            }
                            if (arr.pid) {
                                t.$cookies.set('jspid', arr.pid, '24h', '/', location.host.substr(location.host.indexOf('.')))
                                t.$cookies.set('pid', arr.pid, '24h', '/', location.host.substr(location.host.indexOf('.')))
                                t.Storage.set('jspid', arr.pid, r => {
                                })
                                t.Storage.set('pid', arr.pid, r => {
                                })
                            }
                            location.href = arr.url
                        })
                    } else {
                        if (res.param.indexOf('--extend=') < 0) return
                        let s = res.param.split('--extend=')[1]
                        s = s.split('&')
                        for (let i = 0; i < s.length; i++) {
                            if (s[i].indexOf('pid=') > -1) {
                                let jspid = s[i].split('=')[1].replace('"', '')
                                t.$cookies.set('jspid', jspid, '24h', '/', location.host.substr(location.host.indexOf('.')))
                                t.$cookies.set('pid', jspid, '24h', '/', location.host.substr(location.host.indexOf('.')))
                                t.fnSetPidCookies()
                                t.Storage.set('jspid', jspid, r => {
                                })
                            }
                        }
                    }
                }
            }
        })
        // 获取大厅渠道PID
        t.fnCefGameBox({
            method: 'GetPid',
            success: res => {
                let jspid = t.$cookies.get('jspid') || ''
                if (!jspid && res) {
                    jspid = res.msg
                    t.$cookies.set('jspid', jspid, '24h', '/', location.host.substr(location.host.indexOf('.')))
                    t.$cookies.set('pid', jspid, '24h', '/', location.host.substr(location.host.indexOf('.')))
                    t.fnSetPidCookies()
                    t.Storage.set('jspid', jspid, r => {
                    })
                }
            }
        })
        // 添加消息事件监听
        // t.fnEventListener()
        // 大厅判断逻辑
        t.fnCefGameBox({
            method: 'IsHall',
            success: res => {
                if (res.data.isHall === 1) {
                    t.isHall = true
                } else {
                    t.isHall = false
                }
            }
        })
        // 获取版本信息
        t.clientVersion = typeof window.clientInfo === 'string' ? JSON.parse(window.clientInfo).client_version : window.clientInfo
        // 页面加载成功后执行事件
        t.$nextTick(() => {
            // 添加window.CCJS事件，客户端调用
            window.CCJS = t.CCJS
            // 检测当前是否有用户登录
            t.fnChecking()
            // 被嵌入后通知父级加载完成
            if (window !== top) {
                window.parent.postMessage(JSON.stringify({
                    dataType: 'loadSuccess'
                }), '*')
            }
            // 获取本地配置
            t.fnLocalBoxConfig()
            // 获取本地系统配置
            t.fnGetSysConfig()
            // 获取当前路由名称
            t.fnSwitchNavBg(t.$route.name)
            let ADIMGURL = t.ADSHALLDATA.image_url
            if (document.body.clientWidth < 1490) {
                t.ADSHALLDATA.image_url = ''
            } else {
                t.ADSHALLDATA.image_url = ADIMGURL
            }
        })
    },
    methods: {
        // 设置PID-COOKIES
        fnSetPidCookies () {
            let t = this
            let showurl = location.href
            t.$cookies.set('showurl', t.fnAddPid(showurl), '24h', '/', location.host.substr(location.host.indexOf('.')))
            t.$cookies.set('referrer', (t.fnAddPid(document.referrer || showurl)), '24h', '/', location.host.substr(location.host.indexOf('.')))
        },
        // 导航点击统计
        fnNavClick (id, name) {
            this.DSP.click({
                type: 7,
                pars: this.fnAddPid(location.href),
                url: this.fnAddPid(location.href),
                sourcename: name,
                id: id,
                page_block_id: 1,
                x_position: event.clientX,
                y_position: event.clientY
            })
        },
        // 添加PID
        fnAddPid (u) {
            let pid = this.$cookies.get('jspid') || ''
            let s = ''
            let uu = ''
            if (u.indexOf('#') > -1) {
                uu = u.split('#')
                u = uu[0]
                s = uu[1]
            }
            if (pid && u.indexOf('pid=') < 0) {
                if (u.indexOf('?') > -1) {
                    u = u + '&pid=' + pid
                } else {
                    u = u + '?pid=' + pid
                }
            }
            if (s) {
                if (u.indexOf('?') > -1) {
                    u += '&path=' + s
                } else {
                    u += '?path=' + s
                }
            }
            return u
        },
        // 检测登录态
        fnChecking () {
            ELSDK.SDKAPI(
                'checkLogin',
                {},
                (res) => {
                    if (res.status === 'error') {
                        this.fnLogout(true)
                        this.passiveLogin = false
                        return
                    }
                    this.fnGetYilewanToken()
                    this.passiveLogin = true
                }
            )
        },
        // 获取yilewan_token
        fnGetYilewanToken (reg, status) {
            ELSDK.SDKAPI(
                'ylwtoken',
                {},
                (res) => {
                    if (res.status === 'error') {
                        t.Toast({ content: res.msg })
                        return
                    }
                    let d = res.data
                    if (reg) {
                        d.reg = reg
                    }
                    if (status) {
                        d.status = status
                    }
                    this.fnBoxLogin(d)
                }
            )
        },
        // 盒子登录
        fnBoxLogin (d, fn) {
            let t = this
            if (fn) {
                t.fn = true
            } else {
                t.fn = false
            }
            t.XHR({
                url: t.ports.user.login,
                data: {
                    yilewan_token: d.token,
                    uid: d.uid
                },
                cbFn (res) {
                    if (res.status === 'error') {
                        t.Toast({
                            content: res.info,
                            time: 5000
                        })
                        return
                    }
                    t.$store.commit('FNSTATE', {
                        USER: res.data
                    })
                    t.USER = res.data
                    // 写入用户信息
                    t.Storage.set('USER', res.data, (res) => {
                        t.wndLogin = false
                        t.isLogined = true
                        // 获取用户信息
                        t.fnGetLocalUserInfo()
                    })
                    let loginType = 1
                    if (t.$cookies.get('login_type') === 'phone') {
                        loginType = 2
                    }
                    if (t.$cookies.get('login_type') === 'qq') {
                        loginType = 3
                    }
                    if (t.$cookies.get('login_type') === 'weixin') {
                        loginType = 5
                    }
                    if (t.$cookies.get('login_type') === 'weibo') {
                        loginType = 4
                    }
                    t.DSP.login({
                        dataType: 'login',
                        uid: res.data.uid,
                        passport: res.data.passport,
                        type: loginType,
                        login_type: 2
                    })
                    ELSDK.SDKAPI(
                        'tjlogin',
                        {
                            uid: res.data.uid,
                            source_page: 'yilewan_pcbox',
                            attr: t.$cookies.get('jsGameCode') ? 'game' : '',
                            attr_value: t.$cookies.get('jsGameCode') ? t.$cookies.get('jsGameCode') : '',
                            game_code: t.$cookies.get('jsGameCode') ? t.$cookies.get('jsGameCode') : ''
                        },
                        (res) => { })
                    t.$cookies.remove('login_type')
                    t.$store.commit('FNSTATE', {
                        reFreshPageData: t.$store.state.reFreshPageData + 1
                    })
                    if (fn) return
                    t.fnIdentifyWnd()
                }
            })
        },
        // 退出登录
        fnLogout (hideToast) {
            let t = this
            t.XHR({
                url: t.ports.user.logout,
                cbFn: res => {
                    if (!hideToast) t.Toast({ content: res.info })
                    if (res.status === 'error') return
                    t.fnClearLoginInfo(hideToast)
                    clearInterval(t.vistorTimer)
                    t.vistorTimer = null
                }
            })
            t.DSP.click({
                type: 11,
                pars: '',
                url: location.href,
                sourcename: '退出登录',
                id: 8007,
                page_block_id: 8,
                x_position: event ? event.clientX || 0 : 0,
                y_position: event ? event.clientY || 0 : 0
            })
        },
        fnLoginResult (data, fn) {
            let t = this
            t.$store.commit('FNSTATE', {
                USER: data
            })
            t.USER = data
            // 写入用户信息
            t.Storage.set('USER', data, (res) => {
                t.wndLogin = false
                t.isLogined = true
            })
            t.$store.commit('FNSTATE', {
                reFreshPageData: t.$store.state.reFreshPageData + 1
            })
            if (fn) return
            if (data.isVistor) return
            t.fnIdentifyWnd()
        },
        // 清空登录数据
        fnClearLoginInfo (hideToast) {
            let t = this
            t.wndSwitchAccount = false
            t.isLogined = false
            t.userInfo = {}
            localStorage.removeItem('checkedPhone')
            t.$store.commit('FNSTATE', {
                USER: {},
                welfare: {}
            })
            // t.fnEventListener()
            t.Storage.del(['USER', 'hasGameWnd'])
            t.wndUserCenter = false
            t.USER = {}
            if (hideToast) {
                t.wndLogin = false
            } else {
                t.wndLogin = true
            }
            t.$cookies.remove('statisticed')
        },
        // 导航切换
        fnSwitchNavBg (name) {
            switch (name) {
                case 'HomeMain':
                    this.routeName = 1
                    break
                case 'PageSearch':
                    this.routeName = 2
                    break
                case 'gifts':
                case 'coupon':
                case 'jfq':
                case 'mall':
                    this.routeName = 3
                    break
            }
        },
        // 登录判断
        fnIsLogined (n) {
            if (!store.state.USER.uid) {
                this.isLogined = false
            } else {
                this.isLogined = true
            }
        },
        // 打开活动页面
        fnShowContentBrowser () {
            let data = this.ADSHALLDATA
            let type = data.open_type
            let url = data.redirect_url
            let pars = this.fnAddPid(url)
            let name = data.title || data.game_name
            switch (type) {
                // 轮播类型1|游戏，2|内容，3|无操作，4|外跳
                case 1:
                    this.fnPlayGame(data)
                    break
                case 2:
                    if (!url) {
                        this.Toast({
                            content: '链接为空，请检查'
                        })
                        return
                    }
                    //   this.fnCefGameBox({
                    //     method: 'SendJsMsg',
                    //     data: {
                    //       method: 'wndBrowser', data: { url: url }
                    //     }
                    //   })
                    if (!this.isHall) return
                    this.Storage.get('wndBrowser', (j) => {
                        if (j.data.wndBrowser) {
                            this.$store.commit('FNSTATE', {
                                browserUrl: this.fnFormatUrl(url)
                            })
                        } else {
                            this.fnCefGameBox({
                                method: 'clientOpenWnd',
                                data: {
                                    url: url,
                                    type: 0
                                },
                                success: res => {
                                    this.Storage.set('wndBrowser', 1, (res) => {
                                    })
                                }
                            })
                        }
                    })
                    break
                case 3:
                    break
                case 4:
                    this.fnCefGameBox({
                        method: 'clientOpenBrowser',
                        data: {
                            url: url,
                            type: 1
                        }
                    })
                    break
            }
            this.DSP.click({
                type: type,
                pars: pars,
                url: url,
                sourcename: name,
                id: 5,
                page_block_id: 1,
                x_position: event.clientX,
                y_position: event.clientY
            })
        },
        // 获取用户E币E豆信息
        fnGetUserEbEd () {
            this.XHR({
                url: this.ports.user.ebed,
                data: {
                    token: this.USER.box_token
                },
                cbFn: res => {
                    if (res.status === 'error') return
                    this.userED = res.data.ed
                    this.userEBQ = res.data.ebcoupon + ' 张'
                }
            })
        },
        // 获取本地用户信息
        fnGetLocalUserInfo () {
            this.Storage.get('USER', (res) => {
                if (!res.data || !res.data.USER) return
                this.$store.commit('FNSTATE', {
                    USER: res.data.USER
                })
                this.isLogined = true
                this.USER = res.data.USER
            })
        },
        // 问答返回
        fnFaqBack () {
            this.faqItemDetail = null
        },
        // 问答详情
        fnShowFaqDetail (detail) {
            this.faqItemDetail = detail
        },
        // 问答列表
        fnFaqList () {
            this.XHR({
                url: this.ports.faq.list,
                cbFn: res => {
                    if (res.status === 'error') {
                        this.Toast({
                            content: res.info
                        })
                        return
                    }
                    this.listDataFaq = res.data
                    this.wndFaq = true
                }
            })
        },
        // 获取本地配置存储
        fnLocalBoxConfig () {
            let t = this
            t.Storage.get('boxConfig', (res) => {
                if (!res.data.boxConfig) {
                    t.fnBoxConfig()
                } else {
                    t.fnSetBoxConfigData({
                        data: {
                            config: res.data.boxConfig
                        }
                    })
                    t.boxConfig = true
                }
            })
        },
        // 获取页面初始化配置项
        fnBoxConfig () {
            let t = this
            t.XHR({
                url: t.ports.config,
                cbFn: (res) => {
                    t.fnSetBoxConfigData(res)
                }
            })
        },
        // 设置配置信息
        fnSetBoxConfigData (res) {
            let t = this
            t.inputValueSearch = res.data.config.search_game
            t.inputValueSearchDefault = res.data.config.search_game
            t.btnNetFee = res.data.config.netBarplay
            t.wndLoginSrc = res.data.config.login_url
            t.wndLoginUrl = res.data.config.login_url
            t.$store.commit('FNSTATE', {
                boxConfig: res.data.config
            })
            t.boxConfigData = res.data.config
            t.Storage.set('boxConfig', res.data.config, (res) => {
                t.log(res)
            })
        },
        fnShowMsgDetail (id) {
            this.showMsgDetail[id] = !this.showMsgDetail[id]
            this.txtShowMsgDetail = !this.showMsgDetail[id] ? id + 1 : 0
        },
        // 切换账号提示：是否提示
        fnTipsSwitchAccount () {
            if (this.wndSwitchAccountTipsAgain) {
                localStorage.setItem('wndSwitchAccountTipsAgain', 1)
            } else {
                localStorage.removeItem('wndSwitchAccountTipsAgain')
            }
        },
        // 获取系统设置，并写入store
        fnGetSysConfig () {
            this.fnCefGameBox({
                method: 'GetConfig',
                success: (res) => {
                    this.$store.commit('SYSCONFIG', res.data)
                }
            })
        },
        // 打开窗口
        fnClienOpenWnd (o) {
            this.fnCefGameBox({
                method: 'clientOpenWnd',
                data: {
                    url: o.url
                },
                success: res => {
                    o.success && o.success(res)
                    this.log(res)
                }
            })
        },
        // 格式化url
        fnFormatUrl (u) {
            if (u.indexOf('&url=') > -1) {
                u = decodeURIComponent(u.split('url=')[1])
            }
            return u
        },
        // Client Call Javascript
        CCJS (res) {
            console.log(res)
            this.$store.commit('WNDSTATE', {
                settings: false
            })
            switch (res.method) {
                case 'wndResize':
                    if (res.data.change_type === 1) {
                        this.classWndNmlMax = 'classWndMax'
                    } else {
                        this.classWndNmlMax = 'classWndNml'
                    }
                    break
                case 'ReceiveJSMsg':
                    if (!res.data.method) return
                    switch (res.data.method) {
                        case 'wndAAS':
                            this.fnCefGameBox({
                                method: 'clientOpenWnd',
                                data: {
                                    url: location.protocol + '//account-api.yilewan.com/statics/aas/box.html',
                                    topmost: 1,
                                    status: 0,
                                    width: window.screen.width - 300,
                                    height: window.screen.height - 500
                                },
                                success: res => {}
                            })
                            break
                        case 'wndBlank':
                        case 'wndBrowser':
                            if (!this.isHall) return
                            this.Storage.get('wndBrowser', (j) => {
                                if (j.data.wndBrowser) {
                                    this.$store.commit('FNSTATE', {
                                        browserUrl: this.fnFormatUrl(res.data.data.url)
                                    })
                                } else {
                                    this.fnCefGameBox({
                                        method: 'clientOpenWnd',
                                        data: {
                                            url: this.boxConfigData.wndBrowser + encodeURIComponent(res.data.data.url)
                                        },
                                        success: res => {
                                            this.Storage.set('wndBrowser', 1, (res) => {
                                            })
                                        }
                                    })
                                }
                            })
                            break
                        case 'wndClearBrowserUrl':
                            this.log(res.data)
                            this.$store.commit('FNSTATE', {
                                browserUrl: null
                            })
                            this.Storage.del('wndBrowser')
                            break
                        case 'wndGame':
                            this.fnHasGameWnd()
                            break
                        // cef游戏退弹窗口关闭
                        case 'wndGameClose':
                            this.$store.commit('GAMESTATE', { dataType: 'dele', data: res.data.data })
                            break
                        case 'wndVistorClose':
                            this.$store.commit('GAMEVISTORSTATE', { dataType: 'dele', data: res.data.data })
                            break
                        case 'wndClose':
                            this.$store.commit('HISTORYUPDATE', new Date().getTime())
                            this.Storage.get('hasGameWnd', res => {
                                if (Number(res.data.hasGameWnd)) {
                                    this.Storage.set('hasGameWnd', Number(res.data.hasGameWnd) - 1)
                                    if (Number(res.data.hasGameWnd) === 1) {
                                        this.fnCefGameBox({
                                            method: 'ActiveWindow',
                                            data: { swstatus: 5 }
                                        })
                                    }
                                } else {
                                    this.Storage.set('hasGameWnd', 0)
                                }
                            })
                            break
                        case 'wndCloseFloor':
                            this.fnCefGameBox({
                                method: 'ActiveWindow',
                                data: { swstatus: 5 }
                            })
                            break
                        case 'wndOpenDefaultBrowser':
                            this.fnCefGameBox({
                                method: 'clientOpenBrowser',
                                data: {
                                    url: res.data.data.url
                                }
                            })
                            break
                        case 'linkToFullPay':
                            this.fnPayType(res.data.data.url)
                            break
                        case 'linkToPay':
                            if (res.data.data && res.data.data.url) {
                                this.fnLinkToPay(res.data.data)
                            } else {
                                let payUrl = 'https://pay.yilewan.com/game/index'
                                if (res.data.data.game_code) {
                                    payUrl += '?game_code=' + res.data.data.game_code
                                }
                                if (res.data.data.server_id) {
                                    if (payUrl.indexOf('?') === -1) {
                                        payUrl += '?server_code=' + res.data.data.server_id
                                    } else {
                                        payUrl += '&server_code=' + res.data.data.server_id
                                    }
                                }
                                this.fnPayType(payUrl)
                            }
                            break
                        // 小窗口更多充值方式
                        case 'wndCharge':
                            this.fnPayType(res.url)
                            break
                        case 'floorCallReload':
                            if (this.isHall) {
                                // location.reload()
                                // this.fnBoxLogin(res.data.data.token, true)
                                this.fnChecking()
                            }
                            break
                        case 'wndGameAdClick':
                            let title = ''
                            if (res.data.data.game_name) {
                                title += res.data.data.game_name + ' | '
                            }
                            if (res.data.data.server_name) {
                                title += res.data.data.server_name + ' | '
                            }
                            if (this.$store.state.USER.passport) {
                                title += this.$store.state.USER.passport
                            }
                            let d = {
                                url: res.data.data.redirect_url,
                                type: res.data.data.core_type,
                                window_title: title || '易乐玩游戏盒子',
                                game_name: res.data.data.game_name,
                                game_code: res.data.data.game_code,
                                server_name: res.data.data.serverName,
                                server_id: res.data.data.serverId,
                                passport: this.$store.state.USER.passport,
                                uid: this.$store.state.USER.uid
                            }
                            // open_type类型1|游戏，2|内容，3|无操作，4|外跳
                            switch (res.data.data.open_type) {
                                case 1:
                                    d.type = 0
                                    this.fnCefGameBox({
                                        method: 'clientOpenWnd',
                                        data: d
                                    })
                                    break
                                case 2:
                                    if (!d.url) {
                                        this.Toast({
                                            content: '链接为空，请检查'
                                        })
                                        return
                                    }
                                    if (!this.USER.uid) {
                                        this.Toast({
                                            content: '请先登录'
                                        })
                                    }
                                    this.fnCefGameBox({
                                        method: 'clientOpenWnd',
                                        data: d
                                    })
                                    break
                                case 3:
                                    break
                                case 4:
                                    this.fnCefGameBox({
                                        method: 'clientOpenBrowser',
                                        data: {
                                            url: res.data.data.url,
                                            type: 1
                                        }
                                    })
                                    break
                            }
                            break
                        // 取消关机
                        case 'cancelShutdown':
                            this.$store.commit('FNSTATE', {
                                shutdownData: {}
                            })
                            this.Storage.set('shutdownSecend', -1)
                            break
                        case 'activeHall':
                            this.fnCefGameBox({
                                method: 'ActiveWindow',
                                data: { swstatus: 5 }
                            })
                            break
                        case 'wndIdentify':
                            this.fnIdentifyWnd(true)
                            break
                        case 'wndIdentifyinit':
                            this.fnIdentifyWnd()
                            break
                        case 'wndGameGiftsClose':
                            this.$store.commit('GAMEGIFTSSTATE', { dataType: 'dele', data: res.data.data })
                            break
                        case 'bindSuccess':
                            this.USER.isVistor = 0
                            this.$store.commit('FNSTATE', {
                                USER: this.USER
                            })
                            break
                        case 'wndBind':
                            this.openVistor(res.data.data, 2)
                            break
                        case 'wndGameTj':
                            let tjData = res.data.data
                            this.DSP.ylwheart(tjData)
                            break
                    }
                    break
                case 'wndClose':
                    this.wndClose = true
                    this.Storage.get('hasGameWnd', res => {
                        if (Number(res.data.hasGameWnd) > 0) {
                            this.txtClose = store.state.txt.closeAll
                            this.hasGameWnd = true
                        } else {
                            this.txtClose = store.state.txt.close
                            this.hasGameWnd = false
                        }
                    })
                    break
                case 'wndSetting':
                    this.wndSetting = true
                    break
                case 'wndUpdate':
                    // debugger
                    this.wndCheckUpdate = true
                    this.fnCheckUpdating()
                    break
                case 'wndAboutus':
                    this.wndAboutUs = true
                    break
                case 'wndFeedback':
                case 'wndService':
                    this.fnCefGameBox({
                        method: 'clientOpenBrowser',
                        data: {
                            url: this.boxConfigData.server_url
                        }
                    })
                    break
                case 'wndPlatYLW':
                case 'wndPlatformYLW':
                    this.fnCefGameBox({
                        method: 'clientOpenBrowser',
                        data: {
                            url: this.boxConfigData.website
                        }
                    })
                    break
                case 'wndBlank':
                    this.fnClienOpenWnd({
                        url: this.boxConfigData.wndBrowser + encodeURIComponent(res.url),
                        success: res => {
                            this.log(res)
                        }
                    })
                    break
                case 'wndTitle':
                    this.$store.commit('FNSTATE', {
                        browserTitle: res.data.frameTitle
                    })
                    this.fnCefGameBox({
                        method: 'SetWindowTitle',
                        data: {
                            title: res.data.frameTitle
                        }
                    })
                    break
                // 问答列表
                case 'wndFaq':
                    this.fnFaqList()
                    break
                case 'wndGame':
                    this.fnHasGameWnd()
                    break
                // ie游戏窗口关闭
                case 'wndGameClose':
                    // 打开游戏退弹
                    if (res.data === undefined) {
                        this.Storage.get('hasGameWnd', res => {
                            if (Number(res.data.hasGameWnd)) {
                                this.Storage.set('hasGameWnd', Number(res.data.hasGameWnd) - 1)
                                if (Number(res.data.hasGameWnd) === 1) {
                                    this.fnCefGameBox({
                                        method: 'ActiveWindow',
                                        data: { swstatus: 5 }
                                    })
                                }
                            } else {
                                this.Storage.set('hasGameWnd', 0)
                            }
                        })
                    } else if (res.data) {
                        if (this.USER.isVistor) {
                            this.openVistor(res.data, 1)
                            return
                        }
                        let wndGameObj = res.data
                        let openStatus = true
                        this.gameparams.forEach(item => {
                            if (item.game_window === wndGameObj.game_window) {
                                openStatus = false
                            }
                        })
                        if (!openStatus) return
                        this.$store.commit('GAMESTATE', { dataType: 'push', data: res.data })
                        this.Storage.set('wndGameparams', res.data)
                        this.openGamePop(res.data)
                        this.fnCefGameBox({
                            method: 'SendJsMsg',
                            data: {
                                method: 'wndGameGiftsClose',
                                data: res.data
                            },
                            success () {

                            }
                        })
                    }
                    break
                // ie游戏窗口内游戏链接打开
                case 'wndGameBlank':
                    if (res.url.indexOf('pay.') > -1) {
                        this.fnLinkToPay(res)
                    } else if (res.url.indexOf('Recharge/changeGame') > -1) {
                        this.fnPayType(res.url)
                    } else {
                        this.fnCefGameBox({
                            method: 'clientOpenBrowser',
                            data: {
                                url: res.url
                            }
                        })
                    }
                    break
                // ie游戏窗口发起充值
                case 'wndGameCharge':
                    if (this.USER.isVistor) {
                        this.openVistor(res, 2)
                        return
                    }
                    this.fnLinkToPay(res)
                    break
                // ie游戏窗口发起打开游戏官网
                case 'wndGameOfficial':
                    this.fnCefGameBox({
                        method: 'clientOpenBrowser',
                        data: {
                            url: 'https://' + res.game_code + '.yilewan.com/'
                        }
                    })
                    break
                case 'wndIdentify':
                    if (this.USER.isVistor) {
                        this.openVistor(res.data, 3)
                        return
                    }
                    this.fnIdentifyWnd(true)
                    break
                case 'wndIdentifyinit':
                    this.fnIdentifyWnd()
                    break
                case 'wndGameGifts':
                    if (this.USER.isVistor) {
                        this.openVistor(res.data, 4)
                        return
                    }
                    let wndGameObj = res.data
                    let openStatus = true
                    if (this.gamegiftsparams.length > 0) {
                        this.gamegiftsparams.forEach(item => {
                            if (item.game_window === wndGameObj.game_window) {
                                openStatus = false
                            }
                        })
                    }
                    if (!openStatus) return
                    this.$store.commit('GAMEGIFTSSTATE', { dataType: 'push', data: res.data })
                    this.Storage.set('wndGameGiftsparams', res.data)
                    this.openGiftsPop(res.data)
                    break
                case 'wndBind':
                    this.openVistor(res.data, 5)
                    break
            }
        },
        // 大窗口充值
        fnPayType (url) {
            if (this.USER.isVistor) {
                this.CEF.API('clientOpenWnd', {
                    url: 'http://box.yilewan.com/#/Vistor?type=6',
                    type: 0,
                    window_title: '账号绑定-易乐玩游戏盒子',
                    window_name: '账号绑定',
                    game_name: '',
                    game_code: '',
                    server_name: '',
                    server_id: '',
                    passport: '',
                    uid: this.USER.uid,
                    width: 680,
                    height: 390,
                    center: true,
                    syncookie: 1,
                    topmost: 1,
                    status: 0
                })
            } else {
                this.CEF.API('clientOpenWnd', {
                    url: location.protocol + '//box.yilewan.com/#/Pay?url=' + encodeURIComponent(url),
                    type: 0,
                    window_title: '易乐玩游戏盒子-在线充值',
                    game_name: '',
                    game_code: '',
                    server_name: '',
                    server_id: '',
                    passport: '',
                    uid: this.USER.uid,
                    width: 1250,
                    height: 980,
                    center: true,
                    syncookie: 1
                })
            }
        },
        // 实名认证窗口
        fnIdentifyWnd (fn) {
            let t = this
            return
            if (t.USER.isVistor) return
            t.XHR({
                url: t.ports.user.isIdentify,
                config: { withCredentials: true },
                cbFn: res => {
                    if (res.status === 'error') {
                        t.Toast({
                            content: res.info
                        })
                        return
                    }
                    if (res.data && !res.data.identificationCard) {
                        t.Storage.get('hasIdentifyWnd', res => {
                            if (Number(res.data.hasIdentifyWnd)) {
                                t.fnCefGameBox({
                                    method: 'SendJsMsg',
                                    data: {
                                        method: 'activeIdentify'
                                    },
                                    success: res => {
                                    }
                                })
                            } else {
                                t.fnCefGameBox({
                                    method: 'clientOpenWnd',
                                    data: {
                                        url: 'https://box.yilewan.com/#/Identify',
                                        status: 0,
                                        width: 680,
                                        height: 425,
                                        window_name: '实名认证',
                                        type: 0,
                                        topmost: 1
                                    },
                                    success: r => {
                                        t.Storage.set('hasIdentifyWnd', 1)
                                    }
                                })
                            }
                        })
                    } else {
                        if (!fn) return
                        t.Storage.get('hasIdentifyWnd', res => {
                            if (Number(res.data.hasIdentifyWnd)) {
                                t.fnCefGameBox({
                                    method: 'SendJsMsg',
                                    data: {
                                        method: 'doneIdentify'
                                    },
                                    success: res => {
                                    }
                                })
                            } else {
                                t.fnCefGameBox({
                                    method: 'clientOpenWnd',
                                    data: {
                                        url: 'https://box.yilewan.com/#/Identify?doneIdentify=1',
                                        status: 0,
                                        width: 680,
                                        height: 425,
                                        window_name: '实名认证',
                                        type: 0,
                                        topmost: 1
                                    },
                                    success: r => {
                                        t.Storage.set('hasIdentifyWnd', 1)
                                    }
                                })
                            }
                        })
                    }
                }
            })
        },
        fnHasGameWnd () {
            this.Storage.get('hasGameWnd', res => {
                if (Number(res.data.hasGameWnd)) {
                    this.Storage.set('hasGameWnd', Number(res.data.hasGameWnd) + 1)
                } else {
                    this.Storage.set('hasGameWnd', 1)
                    // 开始1小时游客模式倒计时
                    this.identifyCountDown()
                }
            })
        },
        // 通知打开充值界面
        fnLinkToPay (res) {
            if (!this.isHall) return
            let u = location.protocol + '//box.yilewan.com/#/Pay?url='
            this.XHR({
                url: this.ports.game.recharge,
                data: {
                    uid: res.uid,
                    game_code: res.game_code,
                    server_code: res.server_id
                },
                cbFn: (j) => {
                    if (!j || j.status === 'error') return
                    u += encodeURIComponent(j.data.url)
                    this.CEF.API('clientOpenWnd', {
                        url: u,
                        status: 0,
                        type: 0,
                        window_title: '易乐玩游戏盒子-' + res.game_name + '充值',
                        game_name: res.game_name,
                        game_code: res.game_code,
                        server_name: res.server_name,
                        server_id: res.server_id,
                        passport: res.passport,
                        uid: res.uid,
                        width: 643,
                        height: 462,
                        center: true,
                        syncookie: 1
                    })
                }
            })
        },
        // 大厅关闭逻辑
        fnCloseComputed (c) {
            if (this.isHall) {
                if (store.state.sysConfig.closeType === 1) {
                    this.wndClose = true
                    this.Storage.get('hasGameWnd', res => {
                        if (Number(res.data.hasGameWnd) > 0) {
                            this.txtClose = store.state.txt.closeAll
                            this.hasGameWnd = true
                        } else {
                            this.txtClose = store.state.txt.close
                            this.hasGameWnd = false
                        }
                    })
                } else {
                    this.fnCefGameBox({
                        method: 'clientWndClose'
                    })
                }
            } else {
                this.Storage.get('hasGameWnd', res => {
                    if (Number(res.data.hasGameWnd)) {
                        this.Storage.set('hasGameWnd', Number(res.data.hasGameWnd) - 1)
                    } else {
                        this.Storage.del('hasGameWnd')
                    }
                    this.fnCefGameBox({
                        method: 'clientWndClose'
                    })
                })
            }
        },
        // 按钮点击事件
        fnBtnClick (o) {
            const t = this
            t.$store.commit('WNDSTATE', {
                settings: false
            })
            if (typeof o === 'object') {
                if (o.dataType === 'modalSlotClose') {
                    switch (o.dataClose) {
                        case 'wndSetting':
                            t.wndSetting = false
                            break
                        case 'wndAboutUs':
                            t.wndAboutUs = false
                            break
                        case 'wndCheckUpdate':
                            t.wndCheckUpdate = false
                            break
                        case 'wndPay':
                            t.wndPay = false
                            break
                        case 'wndClose':
                            t.wndClose = false
                            break
                        case 'wndClearCache':
                            t.wndClearCache = false
                            break
                        case 'wndSwitchAccount':
                            t.wndSwitchAccount = false
                            break
                        case 'wndLogin':
                            // debugger
                            t.wndLogin = false
                            t.$store.commit('FNSTATE', {
                                showLogin: false,
                                showRegister: false
                            })
                            break
                        case 'wndThirdLogin':
                            t.wndThirdLogin = false
                            t.wndLogin = true
                            break
                        case 'wndUserCenter':
                            t.wndUserCenter = false
                            break
                        case 'wndUserMsg':
                            t.wndUserMsg = false
                            break
                        case 'wndFaq':
                            t.wndFaq = false
                            break
                    }
                }
            } else {
                switch (o) {
                    //   case 'wndMin':
                    //     t.fnCefGameBox({
                    //       method: 'clientWndMin',
                    //       success: function (res) {
                    //         t.log(res)
                    //       }
                    //     })
                    //     break
                    //   case 'wndNmlMax':
                    //     t.wndNmlMax = !this.wndNmlMax
                    //     if (t.wndNmlMax) {
                    //       t.classWndNmlMax = 'classWndMax'
                    //     } else {
                    //       t.classWndNmlMax = 'classWndNml'
                    //     }
                    //     t.fnCefGameBox({
                    //       method: 'clientWndNmlMax',
                    //       success: function (res) {
                    //         t.log(res)
                    //       }
                    //     })
                    //     break
                    case 'wndClose':
                        // 仅在主窗口内执行
                        if (!t.isHall) {
                            t.fnCefGameBox({
                                method: 'SendJsMsg',
                                data: {
                                    method: 'wndClose'
                                }
                            })
                        }
                        // 内容窗口关闭时清空存储的url
                        if (t.headerType === 'headerBrowser') {
                            t.fnCefGameBox({
                                method: 'SendJsMsg',
                                data: {
                                    method: 'wndClearBrowserUrl'
                                }
                            })
                        }
                        t.fnCloseComputed()
                        break
                    case 'fullScreen':
                        t.fnCefGameBox({
                            method: 'clientFullScreen',
                            success: (res) => {
                                t.log(res)
                                t.isFullScreen = !t.isFullScreen
                                if (t.isFullScreen) {
                                    t.txtFullScreen = '退出全屏'
                                } else {
                                    t.txtFullScreen = '全屏'
                                }
                                t.DSP.click({
                                    type: 3,
                                    pars: '',
                                    url: location.href,
                                    sourcename: t.txtFullScreen,
                                    id: 5,
                                    page_block_id: 2,
                                    x_position: event.clientX,
                                    y_position: event.clientY
                                })
                            },
                            error: (res) => {
                                t.isFullScreen = false
                            }
                        })
                        break
                    case 'clearCache':
                        t.wndClearCache = true
                        setTimeout(() => {
                            t.clearing = false
                        }, 2000)
                        t.DSP.click({
                            type: 10,
                            pars: '',
                            url: location.href,
                            sourcename: '清除缓存',
                            id: 6,
                            page_block_id: 2,
                            x_position: event.clientX,
                            y_position: event.clientY
                        })
                        break
                    case 'doClearCache':
                        t.fnCefGameBox({
                            method: 'clientClearCache',
                            data: {
                                clear_type: 1
                            },
                            success: (res) => {
                                t.log(res)
                            }
                        })
                        break
                    case 'openOfficial':
                    case 'openService':
                        t.Storage.get('boxConfig', (res) => {
                            t.$store.commit('FNSTATE', {
                                boxConfig: res.data.boxConfig
                            })
                            let url = null
                            if (o === 'openOfficial') {
                                if (t.$route.params.id) {
                                    url = 'https://' + t.$route.params.id + '.yilewan.com'
                                } else {
                                    url = store.state.boxConfig.website || res.data.boxConfig.website
                                }
                            } else {
                                url = store.state.boxConfig.server_url || res.data.boxConfig.server_url
                            }
                            t.fnCefGameBox({
                                method: 'clientOpenBrowser',
                                data: {
                                    url: url
                                }
                            })
                        })
                        break
                    case 'search':
                        // console.log('search', t.$route)
                        // 获取当前路由名称
                        t.fnSwitchNavBg('PageSearch')
                        if (t.$route.name === 'PageSearch') {
                            t.$store.commit('FNSTATE', {
                                searchKey: t.inputValueSearch || t.inputValueSearchDefault || '唐门六道3D'
                            })
                        } else {
                            t.$router.push({
                                path: `/search/${t.inputValueSearch}`
                            })
                        }
                        t.DSP.click({
                            type: 8,
                            pars: t.inputValueSearch,
                            url: '',
                            sourcename: t.inputValueSearch,
                            id: 4,
                            page_block_id: 1,
                            x_position: event.clientX,
                            y_position: event.clientY
                        })
                        break
                    case 'privilege':
                        if (t.isLogined) {
                            t.wndPrivilegeJudge = !t.wndPrivilegeJudge
                        } else {
                            t.wndLogin = true
                        }
                        this.DSP.click({
                            type: 2,
                            pars: '',
                            url: '',
                            sourcename: '盒子特权',
                            id: 6,
                            page_block_id: 1,
                            x_position: event.clientX,
                            y_position: event.clientY
                        })
                        break
                    case 'settings':
                        t.$store.commit('WNDSTATE', {
                            settings: !t.settings
                        })
                        t.DSP.click({
                            type: 10,
                            pars: '',
                            url: location.href,
                            sourcename: '打开设置',
                            id: 8,
                            page_block_id: 1,
                            x_position: event.clientX,
                            y_position: event.clientY
                        })
                        break
                    case 'wndSetting':
                        this.sysConfig = store.state.sysConfig
                        t.wndSetting = true
                        t.DSP.click({
                            type: 10,
                            pars: '',
                            url: location.href,
                            sourcename: '系统设置',
                            id: 8001,
                            page_block_id: 1,
                            x_position: event.clientX,
                            y_position: event.clientY
                        })
                        break
                    case 'checkUpdate':
                        t.wndCheckUpdate = true
                        t.fnCheckUpdating()
                        t.DSP.click({
                            type: 10,
                            pars: '',
                            url: location.href,
                            sourcename: '检测更新',
                            id: 8002,
                            page_block_id: 1,
                            x_position: event.clientX,
                            y_position: event.clientY
                        })
                        break
                    case 'aboutUs':
                        t.wndAboutUs = true
                        t.DSP.click({
                            type: 10,
                            pars: '',
                            url: location.href,
                            sourcename: '关于我们',
                            id: 8006,
                            page_block_id: 1,
                            x_position: event.clientX,
                            y_position: event.clientY
                        })
                        break
                    case 'wndFaq':
                        t.fnFaqList()
                        t.DSP.click({
                            type: 10,
                            pars: '',
                            url: location.href,
                            sourcename: '常见问题',
                            id: 8003,
                            page_block_id: 1,
                            x_position: event.clientX,
                            y_position: event.clientY
                        })
                        break
                    case 'saveSetting':
                        t.fnCefGameBox({
                            method: 'SetConfig',
                            data: {
                                setAsAutoRun: t.sysConfig.setAsAutoRun ? 1 : 0,
                                closeType: t.sysConfig.closeType,
                                updateType: t.sysConfig.updateType
                            },
                            success (res) {
                                t.fnGetSysConfig()
                                t.wndSetting = false
                            },
                            error () {
                                t.wndSetting = false
                            }
                        })
                        break
                    case 'historyBack':
                        history.go(-1)
                        t.DSP.click({
                            type: 3,
                            pars: '',
                            url: location.href,
                            sourcename: '后退',
                            id: 2,
                            page_block_id: 1,
                            x_position: event.clientX,
                            y_position: event.clientY
                        })
                        break
                    case 'historyForward':
                        history.forward()
                        t.DSP.click({
                            type: 3,
                            pars: '',
                            url: location.href,
                            sourcename: '前进',
                            id: 1,
                            page_block_id: 1,
                            x_position: event.clientX,
                            y_position: event.clientY
                        })
                        break
                    case 'reload':
                        location.reload()
                        t.DSP.click({
                            type: 3,
                            pars: location.href,
                            url: location.href,
                            sourcename: '刷新',
                            id: 3,
                            page_block_id: 1,
                            x_position: event.clientX,
                            y_position: event.clientY
                        })
                        break
                    case 'charge':
                        t.wndPay = true
                        break
                    case 'exitClient':
                        t.DSP.click({
                            type: 9,
                            pars: '',
                            url: '',
                            sourcename: '退弹',
                            id: 11,
                            page_block_id: 1,
                            x_position: event.clientX,
                            y_position: event.clientY
                        })
                        t.CEF.API('clientOpenWnd', {
                            url: 'http://www.baidu.com',
                            width: 0,
                            height: 0,
                            type: 0,
                            window_title: '',
                            game_name: '',
                            game_code: '',
                            server_name: '',
                            server_id: '',
                            passport: '',
                            uid: ''
                        })
                        t.fnCefGameBox({
                            method: 'ExitClient'
                        })
                        break
                    case 'wndSwitchAccount':
                        if (
                            localStorage.getItem('wndSwitchAccountTipsAgain') &&
                            Number(localStorage.getItem('wndSwitchAccountTipsAgain')) === 1
                        ) {
                            t.wndSwitchAccountTipsAgain = true
                            // 退出逻辑开始
                            t.Toast({
                                content: '退出登录'
                            })
                            t.fnLogout()
                        } else {
                            t.wndSwitchAccount = true
                        }
                        t.DSP.click({
                            type: 9,
                            pars: '',
                            url: '',
                            sourcename: '切换账号',
                            id: 7003,
                            page_block_id: 1,
                            x_position: event.clientX,
                            y_position: event.clientY
                        })
                        break
                    case 'wndDoSwitchAccount':
                        t.fnLogout()
                        break
                    case 'wndLogin':
                        t.wndLogin = true
                        // t.fnEventListener()
                        t.DSP.click({
                            type: 10,
                            pars: '',
                            url: '',
                            sourcename: '登录',
                            id: 7,
                            page_block_id: 1,
                            x_position: event.clientX,
                            y_position: event.clientY
                        })
                        break
                    case 'wndthirdLogin':
                        t.wndthirdLogin = true
                        t.wndLogin = false
                        break
                    case 'userDetail':
                        t.fnCefGameBox({
                            method: 'clientOpenBrowser',
                            data: {
                                url: 'https://www.yilewan.com/my/account'
                            }
                        })
                        break
                    case 'userCenter':
                        t.fnGetUserEbEd()
                        t.wndUserCenter = true
                        t.DSP.click({
                            type: 10,
                            pars: '',
                            url: '',
                            sourcename: '个人中心',
                            id: 7001,
                            page_block_id: 1,
                            x_position: event.clientX,
                            y_position: event.clientY
                        })
                        break
                    case 'wndUserMsg':
                        t.fnCefGameBox({
                            method: 'clientOpenBrowser',
                            data: {
                                url: t.$store.state.boxConfig.message_url
                            }
                        })
                        t.DSP.click({
                            type: 4,
                            pars: t.$store.state.boxConfig.message_url,
                            url: t.$store.state.boxConfig.message_url,
                            sourcename: '消息',
                            id: 7002,
                            page_block_id: 1,
                            x_position: event.clientX,
                            y_position: event.clientY
                        })
                        break
                }
            }
        },
        // 关注公众号
        fnFocusNum (num) {
            let t = this
            t.Storage.get('boxConfig', r => {
                let u = r.data.boxConfig.bindPhone
                let h = 370
                let title = '关注公众号领取礼包'
                t.Storage.get('neverShowAgain', n => {
                    if (n.data.neverShowAgain) {
                        t.fnCefGameBox({
                            method: 'ExitClient'
                        })
                    } else {
                        if (num) {
                            // 游戏窗口关闭
                            t.wndClose = false
                            if (u.indexOf('?') > -1) {
                                u = u + '&wndGameClose=1'
                            } else {
                                u = u + '?wndGameClose=1'
                            }
                            t.fnCefGameBox({
                                method: 'clientOpenWnd',
                                data: {
                                    url: u,
                                    status: 0,
                                    window_name: title,
                                    width: 520,
                                    height: h,
                                    type: 0
                                }
                            })
                            return
                        }
                        // 主动退出
                        if (this.hasGameWnd) {
                            t.fnCefGameBox({
                                method: 'ShowAllWindow',
                                data: {
                                    show: false
                                },
                                success (res) {
                                    t.wndClose = false
                                    t.fnCefGameBox({
                                        method: 'clientOpenWnd',
                                        data: {
                                            url: u,
                                            window_name: title,
                                            width: 520,
                                            height: h,
                                            type: 0
                                        }
                                    })
                                }
                            })
                        } else {
                            t.Storage.del('hasIdentifyWnd')
                            t.fnCefGameBox({
                                method: 'ExitClient'
                            })
                        }
                    }
                })
            })
        },
        // 客户端更新
        fnCheckUpdating () {
            setTimeout(() => {
                this.checkingUpdate = false
                this.checkUpdateDone = true
                this.txtUpdating = store.state.txt.checkUpdateDone
            }, 1000)
            return
            // eslint-disable-next-line
            this.XHR({
                url: this.ports.client.checkVersion,
                data: {
                    version: this.clientVersion || '1.0.0.1001'
                },
                cbFn: (res) => {
                    this.checkingUpdate = false
                    if (res.status === 'error') {
                        this.checkUpdateDone = true
                        this.txtUpdating = store.state.txt.checkUpdateDone
                        // this.checkUpdatingError = true
                        // this.txtUpdating = store.state.txt.checkUpdateError
                        return
                    }
                    if (res.data.upgrade === 11) {
                        this.checkUpdating = true
                    } else {
                        this.checkUpdateDone = true
                        this.txtUpdating = store.state.txt.checkUpdateDone
                    }
                }
            })
        },
        // 打开游戏弹窗
        openGamePop (data) {
            // 判断是否新开
            this.XHR({
                url: this.ports.game.pop,
                method: 'get',
                data: {
                    game_code: data.game_code
                },
                cbFn: (res) => {
                    if (res.status === 'error') {
                        this.fnCefGameBox({
                            method: 'clientWndClose',
                            data: { wndGameparams: data, ishall: 1 },
                            success: res => {
                            }
                        })
                    } else {
                        let d = {
                            url: 'http://box.yilewan.com/#/CloseRemind',
                            status: 0,
                            width: 445,
                            height: 600,
                            center: false,
                            type: 0,
                            topmost: data.game_window,
                            game_code: data.game_code,
                            window_title: '易乐玩游戏盒子'
                        }
                        this.fnCefGameBox({
                            method: 'clientOpenWnd',
                            data: d
                        })
                    }
                }
            })
        },
        //打开游戏礼包窗口
        openGiftsPop (data) {
            let d = {
                url: 'http://box.yilewan.com/#/GameGifts',
                status: 0,
                width: 537,
                height: 380,
                center: false,
                type: 0,
                topmost: data.game_window,
                game_code: data.game_code,
                window_title: '易乐玩游戏盒子',
                window_name: '游戏礼包'
            }
            this.fnCefGameBox({
                method: 'clientOpenWnd',
                data: d
            })
        },
        // 打开账号绑定
        openVistor (data, type) {
            let wndGameObj = data
            let openStatus = true
            if (this.gameVistorparams.length > 0) {
                this.gameVistorparams.forEach(item => {
                    if (item.game_window == wndGameObj.game_window) {
                        openStatus = false
                    }
                })
            }
            if (!openStatus) return
            this.$store.commit('GAMEVISTORSTATE', { dataType: 'push', data: data })
            this.Storage.set('wndGameparams', data)
            let type_ = type ? 1 : type
            let url = 'http://box.yilewan.com/#/Vistor?type=' + type
            let d = {
                url: url,
                status: 0,
                width: 680,
                height: 390,
                center: false,
                type: 0,
                topmost: parseInt(data.game_window),
                game_code: data.game_code,
                window_title: '账号绑定-易乐玩游戏盒子',
                window_name: '账号绑定'
            }
            this.fnCefGameBox({
                method: 'clientOpenWnd',
                data: d
            })
        },
        // 游客1小时倒计时
        identifyCountDown () {
            let maxtime = 60 * 60 //1小时 60*60
            if (this.vistorTimer) {
                return
            }
            this.vistorTimer = setInterval(() => {
                console.log("倒计时开始：" + maxtime)
                if (maxtime >= 0) {
                    maxtime--
                } else {
                    clearInterval(this.vistorTimer)
                    this.fnIdentifyWnd_()
                }
            }, 1000)
        },
        // 强制实名认证窗口
        fnIdentifyWnd_ () {
            let t = this
            t.XHR({
                url: t.ports.user.isIdentify,
                config: { withCredentials: true },
                cbFn: res => {
                    if (res.status === 'error') {
                        t.Toast({
                            content: res.info
                        })
                        return
                    }
                    if (res.data && !res.data.identificationCard) {
                        // t.Storage.get('hasIdentifyWnd', res => {
                        //     if (Number(res.data.hasIdentifyWnd)) {
                        //         t.fnCefGameBox({
                        //             method: 'SendJsMsg',
                        //             data: {
                        //                 method: 'activeIdentify'
                        //             },
                        //             success: res => {
                        //             }
                        //         })
                        //     } else {
                        //         t.fnCefGameBox({
                        //             method: 'clientOpenWnd',
                        //             data: {
                        //                 url: 'https://box.yilewan.com/#/IdentifyFull',
                        //                 status: 0,
                        //                 width: 680,
                        //                 height: 425,
                        //                 window_name: '实名认证',
                        //                 type: 0,
                        //                 topmost: 1
                        //             },
                        //             success: r => {
                        //                 t.Storage.set('hasIdentifyWnd', 1)
                        //             }
                        //         })
                        //     }
                        // })
                        t.fnCefGameBox({
                            method: 'clientOpenWnd',
                            data: {
                                url: 'https://box.yilewan.com/#/IdentifyFull',
                                status: 1,
                                window_name: '实名认证',
                                type: 0,
                                topmost: 1
                            },
                            success: r => {
                            }
                        })
                    }
                }
            })
        }
    }
}
</script>

<style scoped>
.header .inner {
  box-shadow: 0 5px 15px rgba(0, 0, 0, 0.3);
}
</style>
